//Version:0.0.1
//Author:Harsha
//Last Edit:Harsha
//Modified Date:26-08-2025

import instrumentActionTypes from './instrument.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// GET INSTRUMENT RESPONSE
	getParticularInstrumentResponse: null,
	getParticularInstrumentArr: [],
	// GET INSTRUMENT LIST RESPONSE
	fetchInstrumentsArr: [],
	fetchInstrumentsResponse: null,
	// CREATE INSTRUMENT RESPONSE
	createInstrumentResponse: null,
	// UPDATE INSTRUMENT RESPONSE
	updateInstrumentResponse: null,
	// DELETE INSTRUMENT RESPONSE
	deleteInstrumentResponse: null,
};
const instrumentReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/******************** START - GET ALL INSTRUMENT DETAILS ***********************/

		case instrumentActionTypes.GET_INSTRUMENT_LIST_SUCCESS:
			return {
				...state,
				fetchInstrumentsResponse: action.payload,
				fetchInstrumentsArr: docodeHexResponse(
					action.payload,
					'GetInstrumentListDetailsKey',
				),
			};
		case instrumentActionTypes.GET_INSTRUMENT_LIST_FAILURE:
			return {
				...state,
				fetchInstrumentsResponse: action.payload,
				fetchInstrumentsArr: [],
			};

		case instrumentActionTypes.GET_INSTRUMENT_LIST_RESPONSE_CHANGED:
			return { ...state, fetchInstrumentsResponse: null };

		/******************** END - GET ALL INSTRUMENT DETAILS ************************/

		/** ***************** START - CREATE INSTRUMENT DETAILS ***********************/

		case instrumentActionTypes.CREATE_INSTRUMENT_SUCCESS:
			return { ...state, createInstrumentResponse: action.payload };

		case instrumentActionTypes.CREATE_INSTRUMENT_FAILURE:
			return { ...state, createInstrumentResponse: action.payload };

		case instrumentActionTypes.CREATE_INSTRUMENT_RESPONSE_CHANGED:
			return { ...state, createInstrumentResponse: null };

		/*********************** END - CREATE INSTRUMENT DETAILS ***********************/

		/********************** START - UPDATE INSTRUMENT DETAILS  *********************/

		case instrumentActionTypes.UPDATE_INSTRUMENT_SUCCESS:
			return { ...state, updateInstrumentResponse: action.payload };

		case instrumentActionTypes.UPDATE_INSTRUMENT_FAILURE:
			return { ...state, updateInstrumentResponse: action.payload };

		case instrumentActionTypes.UPDATE_INSTRUMENT_RESPONSE_CHANGED:
			return { ...state, updateInstrumentResponse: null };

		/********************** END - UPDATE INSTRUMENT DETAILS  *************************/

		/****************** START - GET/FETCH PARTICULAR INSTRUMENT LIST *****************/

		case instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_SUCCESS:
			return {
				...state,
				getParticularInstrumentResponse: action.payload,
				getParticularInstrumentArr: docodeHexResponse(
					action.payload,
					'GetParticularInstrumentListDetailsKey',
				),
			};
		case instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_FAILURE:
			return { ...state, getParticularInstrumentResponse: action.payload };

		case instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_RESPONSE_CHANGED:
			return { ...state, getParticularInstrumentResponse: null };

		/******************* END - GET/FETCH PARTICULAR INSTRUMENT LIST *******************/

		/************************ START - DELETE  INSTRUMENT LIST *************************/

		case instrumentActionTypes.DELETE_INSTRUMENT_SUCCESS:
			return { ...state, deleteInstrumentResponse: action.payload };

		case instrumentActionTypes.DELETE_INSTRUMENT_FAILURE:
			return { ...state, deleteInstrumentResponse: action.payload };

		case instrumentActionTypes.DELETE_INSTRUMENT_RESPONSE_CHANGED:
			return { ...state, deleteInstrumentResponse: null };

		/************************* END - DELETE  INSTRUMENT LIST **************************/

		default:
			return state;
	}
};
export default instrumentReducer;
